import { sqliteTable, text, real, integer, index } from "drizzle-orm/sqlite-core";

// ============================================================================
// delivery_orders — ใบส่งของ (Delivery Order)
// ============================================================================
export const deliveryOrders = sqliteTable("inventory_delivery_orders", {
  id: text("id").primaryKey(), // ULID
  companyId: text("company_id").notNull(),
  branchId: text("branch_id"),
  orderNo: text("order_no").notNull().unique(),
  partyType: text("party_type", {
    enum: ["customer"],
  }).notNull().default("customer"),
  partyId: text("party_id").notNull(),
  warehouseId: text("warehouse_id").notNull(),
  postingDate: text("posting_date").notNull(),
  remarks: text("remarks"),
  docStatus: integer("doc_status").notNull().default(0), // 0=draft, 1=submitted, 2=cancelled
  // Reference to source document (e.g. Sales Invoice)
  referenceModule: text("reference_module"),
  referenceId: text("reference_id"),
  // Totals
  totalQty: real("total_qty").notNull().default(0),
  totalAmount: real("total_amount").notNull().default(0),
  // Audit
  createdBy: text("created_by"),
  createdAt: text("created_at").notNull(),
  updatedBy: text("updated_by"),
  updatedAt: text("updated_at"),
  deletedBy: text("deleted_by"),
  deletedAt: text("deleted_at"),
}, (table) => ({
  do_company_date_idx: index("do_company_date_idx").on(table.companyId, table.postingDate),
  do_company_party_idx: index("do_company_party_idx").on(table.companyId, table.partyId),
}));

// Type exports
export type DeliveryOrder = typeof deliveryOrders.$inferSelect;
export type NewDeliveryOrder = typeof deliveryOrders.$inferInsert;

// ============================================================================
// delivery_order_items — รายการในใบส่งของ
// ============================================================================
export const deliveryOrderItems = sqliteTable("inventory_delivery_order_items", {
  id: text("id").primaryKey(), // ULID
  deliveryOrderId: text("delivery_order_id").notNull().references(() => deliveryOrders.id),
  itemId: text("item_id").notNull(),
  warehouseId: text("warehouse_id"),
  qty: real("qty").notNull().default(0),
  rate: real("rate").notNull().default(0),
  amount: real("amount").notNull().default(0),
  remarks: text("remarks"),
}, (table) => ({
  doi_delivery_order_idx: index("doi_delivery_order_idx").on(table.deliveryOrderId),
}));

// Type exports
export type DeliveryOrderItem = typeof deliveryOrderItems.$inferSelect;
export type NewDeliveryOrderItem = typeof deliveryOrderItems.$inferInsert;
